import { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api, { errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loading, Empty } from "../components/kit";
import StaffPerformanceView from "../components/StaffPerformanceView";
import PeriodBar from "../components/PeriodBar";

export default function StaffDetail() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const { month, basis, range } = useAuth();
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const [cats, setCats] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    Promise.all([api.get(`/performance/staff/${id}`, { params: { month, basis, start: range?.start, end: range?.end, store_id: sp.get("store") || undefined } }), api.get("/categories")])
      .then(([p, c]) => { setD(p.data); setCats(c.data); })
      .catch((e) => setErr(errMsg(e)));
  }, [id, month, sp, basis, range]);

  if (err) return <Empty>{err}</Empty>;
  if (!d) return <Loading />;
  return (
    <div className="max-w-2xl mx-auto">
      <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-sm text-slate-500 mb-4" data-testid="staff-detail-back"><ArrowLeft className="w-4 h-4" /> Back</button>
      <PeriodBar />
      <div className="bs-eyebrow">{d.store_info.name} · {d.staff.employee_id}</div>
      <h1 className="font-display text-4xl font-extrabold text-[#011E38] tracking-tight mt-1 mb-6" data-testid="staff-detail-name">{d.staff.name}</h1>
      <StaffPerformanceView d={d} cats={cats} />
    </div>
  );
}
